module.exports = __webpack_public_path__ + "static/img/South Korea.b51349c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/flags/South Korea.png
// module id = 14yP
// module chunks = 0